import * as types from "./dadosSolicitante.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  changeState: new Date().getTime(),
  CpfCnpjSolicitante: undefined,
  NomeSolicitante: undefined,
  EmailSolicitante: undefined,
  RgIeSolicitante: undefined,
  TelefoneSolicitante: undefined,
  CelularSolicitante: undefined,
  EnderecoSolicitante: {},
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SOLICITANTE_SET:
      return state.merge({ ...payload, changeState: new Date().getTime() });
    case types.SOLICITANTE_ENDERECO_SET:
      return state.merge({
        EnderecoSolicitante: { ...payload, changeState: new Date().getTime() },
      });
    case types.DADOSSOLICITANTE_RESETFORM:
      return state.merge({
        ...initialState,
        changeState: new Date().getTime(),
      });
    default:
      return state;
  }
};

store.registerDynamicModule("dadosSolicitante", reduce);
